/**
 * Haptic Feedback Utility
 * Provides vibration feedback for user actions via Telegram Web App API
 * 
 * Note: This is a minimal type definition. Full types should be in a global .d.ts file.
 */

/**
 * Get Telegram WebApp instance (with proper type safety)
 */
const getTelegramWebApp = (): any => {
  return (window as any).Telegram?.WebApp;
};

/**
 * Haptic feedback patterns for different actions
 */
export const haptics = {
  /**
   * Light tap - for small interactions (button press, selection)
   */
  light: () => {
    const webApp = getTelegramWebApp();
    webApp?.HapticFeedback?.impactOccurred('light');
  },

  /**
   * Medium impact - for moderate actions (toggle, filter change)
   */
  medium: () => {
    const webApp = getTelegramWebApp();
    webApp?.HapticFeedback?.impactOccurred('medium');
  },

  /**
   * Heavy impact - for significant actions (major button press)
   */
  heavy: () => {
    const webApp = getTelegramWebApp();
    webApp?.HapticFeedback?.impactOccurred('heavy');
  },

  /**
   * Success notification - for successful operations
   */
  success: () => {
    const webApp = getTelegramWebApp();
    webApp?.HapticFeedback?.notificationOccurred('success');
  },

  /**
   * Error notification - for failed operations
   */
  error: () => {
    const webApp = getTelegramWebApp();
    webApp?.HapticFeedback?.notificationOccurred('error');
  },

  /**
   * Warning notification - for warnings
   */
  warning: () => {
    const webApp = getTelegramWebApp();
    webApp?.HapticFeedback?.notificationOccurred('warning');
  },

  /**
   * Selection changed - for list/option selection
   */
  selection: () => {
    const webApp = getTelegramWebApp();
    webApp?.HapticFeedback?.selectionChanged();
  },

  /**
   * Custom pattern: Expense Added
   * Simple success notification
   */
  expenseAdded: () => {
    const webApp = getTelegramWebApp();
    webApp?.HapticFeedback?.notificationOccurred('success');
  },

  /**
   * Custom pattern: TON Settlement Complete
   * Heavy impact + success (big deal!)
   */
  tonSettlement: () => {
    const webApp = getTelegramWebApp();
    webApp?.HapticFeedback?.impactOccurred('heavy');
    setTimeout(() => {
      const webApp = getTelegramWebApp();
      webApp?.HapticFeedback?.notificationOccurred('success');
    }, 100);
  },

  /**
   * Custom pattern: Manual Settlement
   * Medium impact + success
   */
  manualSettlement: () => {
    const webApp = getTelegramWebApp();
    webApp?.HapticFeedback?.impactOccurred('medium');
    setTimeout(() => {
      const webApp = getTelegramWebApp();
      webApp?.HapticFeedback?.notificationOccurred('success');
    }, 80);
  },
};

export default haptics;

